import React, {ReactNode} from "react";
import DashboardSidebars from "@/components/SideElements/DashboardSidebars.tsx";
import st from "@/styles/GenComponent.module.scss";
import ChevroneBtn from "@/ui/ChevroneBtn.tsx";
import {DashboardHeaderType} from "@/types_and_interfaces/types";
import clsx from "clsx";
import { useNavigate } from 'react-router-dom';
import DashboardMobileHeader from "@/components/DashboardMobileHeader.tsx";
import StepsInterface from "@/types_and_interfaces/sidebar_steps_interface.ts";
import HeaderSteps from "@/ui/ConfirmIdentSteps.tsx";

interface Props {
    column_center: ReactNode
    header_type: DashboardHeaderType
    column_right?: ReactNode
    heading?: ReactNode
    backFunction?:boolean
    header_content?: ReactNode
    backUrl?: string
    onBackClick?():void
    full_bg?:boolean
    corner_image?: ReactNode
    center_expanded?: boolean
    light_gray_bg?: boolean
    responsive1?:boolean
    overlaying_elements?: ReactNode
    centered_content?:boolean
    centered_content_expanded?:boolean
    steps?:Array<StepsInterface>
    bottom_bar_content?: ReactNode
}

const DashboardGenComponent:React.FC<Props> = (props) => {
    
    
    const {
        column_center,
        column_right,
        heading,
        backFunction,
        header_content,
        header_type,
        backUrl,
        onBackClick,
        full_bg,
        corner_image,
        center_expanded,
        light_gray_bg,
        responsive1,
        overlaying_elements,
        centered_content,
        centered_content_expanded,
        steps,
        bottom_bar_content
    } = props
    
    const navigate = useNavigate();
    
    
    
    return (
        
        <>
            <div className={clsx(
                st.gen_component,
                center_expanded && st.expanded,
                full_bg && st.full_bg,
                (header_type === "primary" && full_bg) && st.primary,
                (header_type === "dark" && full_bg) && st.dark,
                (header_type === "secondary" && full_bg) && st.secondary,
                (header_type === "gray" && full_bg) && st.gray,
                (header_type === "danger" && full_bg) && st.danger,
                light_gray_bg && st.light_gray_bg,
                responsive1 && st.responsive1,
                centered_content && st.centered_content,
                centered_content_expanded && st.centered_content_expanded
            )}>
                
                {corner_image && corner_image}
                
                {overlaying_elements && overlaying_elements}
                
                <DashboardSidebars steps={steps} />
                
                <DashboardMobileHeader/>
                
                <div
                    className={clsx(
                        st.header,
                        header_type === "primary" && st.primary,
                        header_type === "dark" && st.dark,
                        header_type === "secondary" && st.secondary,
                        header_type === "gray" && st.gray,
                        header_type === "danger" && st.danger,
                        header_type === "hidden" && st.hidden,
                        
                    )}
                >
                    <div className={st.inner}>
                        <div className={st.heading}>
                            
                            {((typeof backUrl === "string" && Boolean(backUrl.length)) || typeof onBackClick === "function") && (
                                <ChevroneBtn
                                    onClick={() => {
                                        if (typeof onBackClick === "function") {
                                            onBackClick()
                                        }
                                        
                                        if(backUrl) {
                                            navigate(backUrl)
                                        }
                                    }}
                                    className={st.back}
                                    direction={"left"}
                                />
                            )}
                            
                            {backFunction && (
                                <ChevroneBtn
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                    className={st.back}
                                    direction={"left"}
                                />
                            )}
                            
                            {heading && heading}
                            
                            {header_content && header_content}
                            
                            {steps && <HeaderSteps steps={steps} />}
                            
                        </div>
                        
                        {column_right && (
                            <div className={clsx(st.right_column)}>
                                {column_right}
                            </div>
                        )}
                        
                    </div>
                
                </div>
                
                <div className={clsx(st.sides)}>
                    <div className={st.inner}>
                        <div className={clsx(st.columns, st.left, center_expanded && st.expanded)}>
                            {column_center}
                        </div>
                    </div>
                </div>
                
                {bottom_bar_content && (
                    <div className={clsx(st.bottom)}>
                    
                    </div>
                )}
            
            </div>
        
        </>
    )
}

export default DashboardGenComponent